var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showOverlay,
          expression: "showOverlay"
        }
      ],
      staticClass: "popup-overlay"
    },
    [
      _c("div", { staticClass: "overlay-top-bar" }, [
        _c(
          "button",
          { staticClass: "back-button", on: { click: _vm.handleCancel } },
          [
            _c("InlineSvg", {
              attrs: { src: "/images/icons/ic-arrow-left.svg" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.enableFileUpload
          ? _c(
              "button",
              {
                staticClass: "top-action-button",
                on: { click: _vm.handleChooseNewFile }
              },
              [_vm._v(_vm._s(_vm.$t("Choose new photo")))]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "overlay-content" },
        [
          _c("ImageCropper", {
            ref: "imageCropper",
            attrs: {
              stencilType: _vm.stencilType,
              aspectRatio: _vm.aspectRatio,
              isMobile: true
            },
            on: {
              imageCropped: _vm.imageCropped,
              ready: function($event) {
                _vm.cropperReady = true
              },
              failInit: _vm.handleCancel
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "overlay-footer" },
        [
          _c(
            "AppButton",
            {
              staticClass: "footer-button",
              attrs: { outline: "", name: "image_cropper_overlay_cancel" },
              on: { click: _vm.handleCancel }
            },
            [
              _c("span", { staticClass: "override-text-style" }, [
                _vm._v(_vm._s(_vm.$t("Cancel")))
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "AppButton",
            {
              staticClass: "footer-button",
              attrs: {
                disabled: !_vm.cropperReady,
                loading: _vm.loading,
                name: "image_cropper_overlay_save"
              },
              on: { click: _vm.handleSave }
            },
            [
              _c("span", { staticClass: "override-text-style" }, [
                _vm._v(_vm._s(_vm.$t("Use this photo")))
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.enableFileUpload
        ? _c("FileUpload", {
            ref: "file-upload",
            attrs: {
              accepts: "image/jpg,image/jpeg,image/png,image/gif",
              multiple: false,
              confirmUpload: false
            },
            on: { filePicked: _vm.filePicked, assetUp: _vm.imageUploaded }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }